/* staffel-click-fix.js
   Klick auf eine Zeile der BSS-Staffeltabelle setzt die Menge zuverlaessig auf
   die Mindestmenge dieser Zeile und haelt sie kurz fest. Verhindert das
   Zurueck-/Runterspringen, das entsteht, wenn BSS, das VPE-Snapping des
   Mengenfeldes oder der Attribut-Observer den Wert nach dem Klick ueberschreiben. */
(function () {
  'use strict';

  var nativeSetter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;

  function parseMinQty(text) {
    if (!text) return null;
    var m = text.match(/\d[\d.\s]*/);
    if (!m) return null;
    var n = parseInt(m[0].replace(/[.\s]/g, ''), 10);
    return (isNaN(n) || n <= 0) ? null : n;
  }

  function isCartCtx(el) {
    return el.closest('#Cart-Drawer') || el.closest('cart-drawer') ||
           el.closest('.product-modal') || el.closest('modal-dialog');
  }

  function findQtyInput() {
    var inputs = document.querySelectorAll('input.qty, input[name="quantity"]');
    for (var i = 0; i < inputs.length; i++) {
      if (isCartCtx(inputs[i])) continue;
      var s = window.getComputedStyle(inputs[i]);
      if (s.display !== 'none' && s.visibility !== 'hidden' && inputs[i].offsetWidth > 0) return inputs[i];
    }
    return inputs.length ? inputs[0] : null;
  }

  // Erkennt eine Zeile einer Mengen/Preis-Staffeltabelle (Menge in Spalte 1, Preis irgendwo rechts).
  function isTierRow(row) {
    if (!row || isCartCtx(row)) return false;
    var cells = row.querySelectorAll('td, th');
    if (cells.length < 2) return false;
    if (parseMinQty(cells[0].textContent) === null) return false;
    for (var i = 1; i < cells.length; i++) {
      if (/\d[.,]\d{2}/.test(cells[i].textContent)) return true;
    }
    return false;
  }

  function setQty(input, qty) {
    // Min-Attribut darf die geklickte (ggf. kleinere) Menge nicht blockieren.
    var curMin = parseInt(input.getAttribute('min'), 10) || 1;
    if (qty < curMin) input.setAttribute('min', qty);
    if ((parseInt(input.value, 10) || 0) === qty) return;
    nativeSetter.call(input, qty);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  document.addEventListener('click', function (e) {
    var row = e.target.closest('tr');
    if (!isTierRow(row)) return;
    var qty = parseMinQty(row.querySelector('td, th').textContent);
    if (qty === null) return;
    var input = findQtyInput();
    if (!input) return;

    setQty(input, qty);

    // Kurzes Fenster: alles, was den Wert direkt nach dem Klick wieder
    // verstellt (BSS-Re-Render, VPE-Snap, Attribut-Observer), zuruecksetzen.
    var until = Date.now() + 1000;
    var iv = setInterval(function () {
      if (Date.now() > until) { clearInterval(iv); return; }
      if ((parseInt(input.value, 10) || 0) !== qty) setQty(input, qty);
    }, 50);
  }, true);
})();
